import React, { Component } from 'react'
import { navigate } from 'gatsby'
import Link from '../utils/link'
import Select from 'react-select'
import { getMarketoCookie } from '../utils/marketo'
import { readCookie, parseCookieToObject } from '../utils/cookie'

const typeOptions = [
  { label: "Residential Sales", value: "Residential Sales"},
  { label: "Commercial", value: "Commercial"},
  { label: "New Projects", value: "New Projects"},
  { label: "Leasing", value: "Leasing"},
  { label: "Careers", value: "Careers"},
]

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

class ContactForm extends Component {

  state = {
    firstname: '',
    lastname: '',
    email: '',
    mobile: '',
    comment: '',
    type_of_enquiry: this.props.type ? { label: "New Projects", value: "New Projects"} : '',
    register: true,
    is_website: true,
    form_name: 'Contact',
    thankYou: '/contact-us/thank-you/',
    agent_email: 'andrewm@kollosche.com.au',
    isSubmitting: false,
  }

  constructor(props) {
    super(props)
    this.form = React.createRef()
  }

  componentDidMount() {
    let cookie = getMarketoCookie()
    this.setState({ cookie })
    if ( typeof window !== 'undefined' ) {
      switch (window.location.pathname) {
        case '/residential/':
          this.setState({ 
            form_name: 'Residential Division from Contact',
            thankYou: '/residential/thank-you/'
          })
          break
        case '/commercial/':
          this.setState({ 
            form_name: 'Commercial Division from Contact',
            thankYou: '/commercial/thank-you/' 
          })
          break
        case '/new-projects/':
          this.setState({ 
            form_name: 'New Projects Division from Contact' ,
            thankYou: '/new-projects/thank-you/'
          })
          break
        case '/property-management/':
          this.setState({ 
            form_name: 'Property Management Division from Contact',
            thankYou: '/property-management/thank-you/'
          })
          break
        default:
          this.setState({ 
            form_name: 'Contact',
            thankYou: '/contact-us/thank-you/'
          })
          break
      }
    }
  }

  handleChange = e => {
    if (e.target.type === 'checkbox') {
      this.setState({ [e.target.name]: e.target.checked })
    } else {
      this.setState({ [e.target.name]: e.target.value })
    }
  }

  handleSelectChange = (option, field) => {
    let state = {}
    switch (field && field.action) {
      case 'select-option':
        state[field.name] = option
        this.setState(state)
        break
      default:
        let { name, value } = option.currentTarget
        state[name] = value
        this.setState(state)
        break
    }
  }

  handleSubmit = e => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false

    // Disable the submit button
    this.setState({ isSubmitting: true })

    let message = `
      Contact Form Submission
      via ${window?.location?.href}

      ${this.state.type_of_enquiry?.value}
      ${this.state.comment}
    `

    let state = this.state
    for (let key in state) {
      if (typeof state[key] === 'object' && state[key] !== null && state[key].hasOwnProperty('value')) {
        state[key] = state[key].value
      }
    }

    let utmFromCookie = readCookie('utmParameters');
    utmFromCookie = parseCookieToObject(utmFromCookie)

    // Include UTM values in the form data
    const formData = {
      message,
      ...utmFromCookie,
      ...state,
    };

    // Send the form data to the server
    return fetch(`https://kollosche.codedrips.com/wp-json/team/v1/enquiry`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode(formData),
    })
    .then(res => res.json())
    .then((res) => {
      console.log(res.response);
      if (res?.response?.status === 'success') navigate(this.state.thankYou);
      if (res?.response?.errors) {
        this.setState({
          result: 'fail',
          msg: res.response.errors.map(err => err.detail.split('\n').map((el, i) => <div key={i}>{ el }</div>))
        });
      }
    })
    .catch(error => this.setState({ result: 'fail', msg: error }))
    .finally(() => {
      // Re-enable the submit button after the request completes
      this.setState({ isSubmitting: false })
    });
  }

  render() {

    let props = {
      ref: this.form,
      name: 'contact',
      className: 'form',
      onSubmit: this.handleSubmit,
    }

    return (

      <form {...props}>

        <div className='column_left'>

          { this.state.msg && <div className='error'>{ this.state.msg }</div> }

          <div className='form__row form__row--double'>

              <div>

                <label htmlFor='first-name-field'>First Name</label>

                <input type='text' name='firstname' id='first-name-field' className='form__input' onChange={this.handleChange} required />

              </div>

              <div>

                <label htmlFor='last-name-field'>Last Name</label>

                <input type='text' name='lastname' id='last-name-field' className='form__input' onChange={this.handleChange} required />

              </div>

          </div>
         
          <div className='form__row'>

            <label htmlFor='email-field'>Your Email</label>

            <input type='email' name='email' id='email-field' className='form__input' onChange={this.handleChange} required  />
    
          </div>

          <div className='form__row'>

            <label htmlFor='contact-field'>Contact Number</label>

            <input type='text' name='mobile' id='contact-field' className='form__input' onChange={this.handleChange} required  />

          </div>

        </div>

        <div className='column_right'>

          { !this.props.type &&

            <div className='form__row'>

              <label htmlFor='address'>Type of Enquiry</label>

              <div className='form__select form__select--blue'>
                <Select
                  options={typeOptions}
                  onChange={this.handleSelectChange}
                  openMenuOnFocus={true}
                  id="type"
                  name="type_of_enquiry"
                  placeholder="Please select"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  required={true}
                  ref={node => this.type = node}
                />
              </div>

            </div>
          
          }

          <div className='form__row'>
            <textarea name='comment' placeholder='Your Message' className='form__input form__textarea' onChange={this.handleChange} />
          </div>

          <div className='form__row form__row--submit'>

            <div className='form__checkbox'>
              <input type='checkbox' name='register' defaultChecked={this.state.register} id='contact-register-field' className='form__input' onChange={this.handleChange}  />
              <label htmlFor='contact-register-field'>By ticking this box, you consent to receive marketing communications from Kollosche as per our <strong><Link to='/privacy-policy/'>Privacy Policy. </Link></strong> </label>
            </div>
            
            <button type='submit' className='btn btn--border' disabled={this.state.isSubmitting}>Send Enquiry</button>
          
          </div>

        </div>

      </form>
    )
  }
}

export default ContactForm